<script setup>
import Icon from "../Common/Icon.vue";
import { useSubscriptionStore } from "../../stores/subscription";
import { useI18n } from "vue-i18n";

const subscriptionStore = useSubscriptionStore();
const { t } = useI18n();

</script>

<template>
  <div class="pt-6 md:pt-8 border-t border-primary/30">
    <div class="bg-primary/5 dark:bg-primary/10 rounded-xl p-6 lg:p-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
      <div>
        <h3 class="text-20 lg:text-25 font-bold mb-2">
          Klarnachrichten <span class="kn-plus-badge">Plus</span>
        </h3>
        <p class="text-14 lg:text-16 text-dark/60 dark:text-light/60 mb-3" v-t="'subscription.upsell.description'"></p>
        <ul class="space-y-2">
          <li class="flex items-center gap-x-3 text-14 lg:text-16">
            <Icon name="filter" class="size-4 shrink-0 text-primary" />
            <span v-t="'subscription.banner.feature.filters'"></span>
          </li>
          <li class="flex items-center gap-x-3 text-14 lg:text-16">
            <Icon name="mail" class="size-4 shrink-0 text-primary" />
            <span v-t="'subscription.banner.feature.email'"></span>
          </li>
          <li class="flex items-center gap-x-3 text-14 lg:text-16">
            <Icon name="volume" class="size-4 shrink-0 text-primary" />
            <span v-t="'subscription.banner.feature.tts'"></span>
          </li>
        </ul>
      </div>

      <button
        type="button"
        @click="subscriptionStore.openCheckout()"
        class="bg-primary text-white dark:text-black font-bold py-3 px-6 rounded-lg text-14 lg:text-16 transition hover:opacity-90 shrink-0 whitespace-nowrap"
        v-t="'subscription.banner.cta'"
      ></button>
    </div>
  </div>
</template>

<style scoped>
.kn-plus-badge {
  color: rgb(var(--color-primary));
  position: relative;
  display: inline-block;
}

.kn-plus-badge::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0.05em;
  height: 0.12em;
  background: rgb(var(--color-primary));
  border-radius: 0.06em;
  opacity: 0.85;
}
</style>
